module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-enter-guiding"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "slogan"
  }, [_vm._v("入驻流程")]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "flow-item"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "pic-commit-info@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("提交资料")])]), _vm._v(" "), _c('div', {
    staticClass: "flow-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow-item"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "pic-auth@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("审核")])]), _vm._v(" "), _c('div', {
    staticClass: "flow-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow-item"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "pic-sign@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("签约")])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.apply($event)
      }
    }
  }, [_vm._v("立即申请")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advantage"
  }, [_c('div', {
    staticClass: "advantage-item"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-01"
  }), _vm._v(" "), _c('span', {
    staticClass: "advantage-name"
  }, [_vm._v("保护版权")]), _vm._v(" "), _c('span', {
    staticClass: "advantage-desc"
  }, [_vm._v("发现盗版或侵权行为立即处理绝不姑息")])]), _vm._v(" "), _c('div', {
    staticClass: "advantage-item"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-02"
  }), _vm._v(" "), _c('span', {
    staticClass: "advantage-name"
  }, [_vm._v("流量资源")]), _vm._v(" "), _c('span', {
    staticClass: "advantage-desc"
  }, [_vm._v("喜马拉雅FM拥有3.3亿用户日均使用时长126钟，为内行业之最")])]), _vm._v(" "), _c('div', {
    staticClass: "advantage-item"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-03"
  }), _vm._v(" "), _c('span', {
    staticClass: "advantage-name"
  }, [_vm._v("数据分析")]), _vm._v(" "), _c('span', {
    staticClass: "advantage-desc"
  }, [_vm._v("提供丰富的分析数据来为您的运营策略提供有力的支撑")])]), _vm._v(" "), _c('div', {
    staticClass: "advantage-item"
  }, [_c('i', {
    staticClass: "icon icon-32 icon-flow-04"
  }), _vm._v(" "), _c('span', {
    staticClass: "advantage-name"
  }, [_vm._v("持续受益")]), _vm._v(" "), _c('span', {
    staticClass: "advantage-desc"
  }, [_vm._v("持续享受流量红利带来的收益分成")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fba225a!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/InnerEnterGuiding.vue
// module id = 1036
// module chunks = 0